<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="5">
        <p class="mb-1 text-caption">Kind</p>
        <p class="display-1 accent--text">{{ getCommDetail.kind | customPlaceholder }}</p>
      </v-col>

      <v-col cols="12" md="7">
        <p class="mb-1 text-caption">Timestamp</p>
        <p class="display-1 accent--text">{{ getCommDetail.timestamp | formatDate('YYYY-MM-DD HH:mm')}}</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="5" class="pt-0">
        <div class="d-flex align-center mb-1">
          <p class="mb-0 mr-1 text-caption">System</p>
          <BaseInfoTooltip top>The system where the comm is being sent from </BaseInfoTooltip>
        </div>
        <p><b>{{ getCommDetail.system | customPlaceholder }}</b></p>
      </v-col>

      <v-col cols="12" md="7" class="pt-0">
        <div class="d-flex align-center mb-1">
          <p class="mb-0 mr-1 text-caption">Name</p>
          <BaseInfoTooltip top>The name of the template used for the communication</BaseInfoTooltip>
        </div>
        <p><b>{{ getCommDetail.name | customPlaceholder }}</b></p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="5" class="pt-0">
        <p class="mb-1 text-caption">Recipient</p>
        <p><b>{{ getCommDetail.recipient | customPlaceholder }}</b></p>
      </v-col>

      <v-col cols="12" md="7" class="pt-0">
        <p class="mb-1 text-caption">User</p>
        <p><b>{{ getCommDetail.user | customPlaceholder }}</b></p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="5" class="pt-0">
        <p class="mb-1 text-caption">Sender</p>
        <p><b>{{ getCommDetail.sender | customPlaceholder }}</b></p>
      </v-col>
    
      <v-col cols="12" md="7" class="pt-0">
        <div class="d-flex align-center mb-1">
          <p class="mb-0 mr-1 text-caption">Trigger</p>
          <BaseInfoTooltip top>Event that caused the comm to be sent</BaseInfoTooltip>
        </div>
        <p><b>{{ getCommDetail.trigger | customPlaceholder }}</b></p>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-0">
        <div class="d-flex align-center mb-1">
          <p class="mb-0 mr-1 text-caption">Duration</p>
          <BaseInfoTooltip top>Duration of phone call</BaseInfoTooltip>
        </div>
        <p><b>{{ getCommDetail.duration | customPlaceholder }}</b></p>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-0">
        <p class="mb-1 text-caption">Contents</p>
        <template v-if="showEmail">
          <iframe :srcdoc="emailContents" sandbox width="100%" height="auto"></iframe>
        </template>
        <template v-else>
          <p><b>{{ getCommDetail.contents | customPlaceholder }}</b></p>             
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { mdiAlertCircle } from '@mdi/js';

  export default {
    data() {
      return {
        mdiAlertCircle,
      }
    },

    computed: {
      ...mapGetters('comms', ['getCommDetail']),

      showEmail() {
        return this.getCommDetail.kind === 'email' && this.getCommDetail.contents;
      },

      emailContents() {
        return `<div>${this.getCommDetail.contents}</div>`;
      }
    },
  }
</script>